module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['wrapper'],
    style: (_vm._px2rem(_vm.dynamicWrapperStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(!!_vm.digitalComp.bgImg) ? _c('div', {
    staticClass: "png-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("main-bg", [_c('figure', {
    staticClass: "png weex-el weex-image",
    attrs: {
      "src": _vm.digitalComp.bgImg,
      "data-img-src": _vm.digitalComp.bgImg,
      "weex-type": "image"
    }
  })], {})], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custorm-animate-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("custorm-animate", null, {})], 2), _vm._v(" "), _vm._t("main-lottie", [(!!_vm.lottieComp[0].data) ? _c('midea-lottie-view', {
    staticClass: "lottie",
    style: ({
      width: _vm._px2rem(_vm.lottieComp[0].width, 75),
      height: _vm._px2rem(_vm.lottieComp[0].height, 75)
    }),
    attrs: {
      "data": _vm.lottieComp[0].data,
      "loop": _vm.lottieComp[0].loop
    }
  }) : _vm._e()], {}), _vm._v(" "), _c('div', {
    staticClass: "digital-wrapper weex-ct weex-div",
    style: (_vm._px2rem(_vm.digitalStyleComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "digital weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "top-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "top-title-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textColorCalc(_vm.digitalComp), 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.digitalComp.title))])]), _vm._v(" "), _c('div', {
    staticClass: "main-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "main-title-value weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "main-title-unit weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textColorCalc(_vm.digitalComp), 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.digitalComp.unit))])]), _vm._v(" "), _c('p', {
    staticClass: " weex-el weex-text",
    class: ['main-title-value-text', _vm.dynamicStateTextSize],
    style: (_vm._processExclusiveStyle(_vm.textColorCalc(_vm.digitalComp), 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.digitalComp.value))])])]), _vm._v(" "), (!!_vm.digitalComp.desc) ? _c('div', {
    staticClass: "desc-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.digitalComp.desc), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: " weex-ct weex-div",
      class: ['desc', _vm.alignStyleCalc(index, _vm.digitalComp.desc)],
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "desc-title weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "desc-title-text weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.textColorCalc(item), 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "desc-value weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: "desc-value-text weex-el weex-text",
      style: (_vm._processExclusiveStyle(_vm.textColorCalc(item), 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.value))])]), _vm._v(" "), (index < _vm.digitalComp.desc.length - 1) ? _c('div', {
      staticClass: "desc-item-split-line weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e()])
  }), 0) : _vm._e()])]), _vm._v(" "), _vm._t("stuas-bar", [_c('div', {
    staticClass: "status-bar-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("second-lottie", [(_vm.lottieComp[1] && !!_vm.lottieComp[1].data) ? _c('midea-lottie-view', {
    staticClass: "second-lottie",
    style: ({
      width: _vm._px2rem(_vm.lottieComp[1].width, 75),
      height: _vm._px2rem(_vm.lottieComp[1].height, 75)
    }),
    attrs: {
      "data": _vm.lottieComp[1].data,
      "loop": _vm.lottieComp[1].loop
    }
  }) : _vm._e()], {}), _vm._v(" "), (_vm.state !== 'offline') ? _c('div', {
    staticClass: "status-bar weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['status-bar-title'],
    style: ({
      backgroundColor: _vm.StatusBarBgColorCalc(_vm.digitalComp)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "status-bar-title-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.digitalComp.status))])])]) : _vm._e()], 2)], {})], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8534e1ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8534e1ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-digital-panel/index.vue
// module id = 639
// module chunks = 0 1